import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/done",
      name: "done",
      component: () => import("./views/Done.vue"),
    },
    {
      path: "/form/:id",
      name: "form",
      component: () => import("./views/FormSimple.vue"),
    },
    {
      path: "/404",
      name: "404",
      component: () => import("./views/404.vue"),
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
});

export default router;